( function () {
    'use strict';
    espresso.ecom.configurator = {};
    espresso.ecom.configurator.init = function () {
        var jConfigForm = jQuery( '.js-e-configurator-form' );
        if ( jConfigForm.length > 0 ) {
            jConfigForm.find( '.control-group' ).each( function () {
                var jThisOptions = jQuery( this ).find( 'input[type="radio"]' ).on( 'change', function () {
                    espresso.ecom.updatePrice( jQuery( this ).closest( 'form' ) );
                } );
                if ( jThisOptions.filter( ':checked' ).length === 0 ) {
                    jThisOptions.first().prop( 'checked', true );
                }
                jThisOptions.filter( ':checked' ).triggerHandler( 'change' );
            } );
        }
    };
}() );
